import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import domPurify from 'dompurify'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

function Markup ({ value, type, unescape, className, style, ...rest }) {
  const item = useMemo(() => {
    if (value !== null && typeof value === 'object') {
      return null
    }
    if (Array.isArray(value)) {
      return null
    }
    if ([null, undefined].includes(value)) {
      return null
    }

    switch (type) {
      case 'html': {
        const _html = unescape ? value.replaceAll('&lt;', '<').replaceAll('&gt;', '>') : value
        return domPurify.sanitize(_html)
      }
      case 'markdown':
      case 'plain':
      default:
        return value
    }
  }, [value, type, unescape])

  if (!item) return null

  const _style = { fontWeight: '100', ...(style || {}) }
  switch (type) {
    case 'html':
      return (<div dangerouslySetInnerHTML={{ __html: item }} className={className} style={_style} {...rest} />)
    case 'markdown':
      return (
        <div style={_style} {...rest}>
          <ReactMarkdown className={className} remarkPlugins={[remarkGfm]}>
            {item}
          </ReactMarkdown>
        </div>
      )
    case 'plain':
    default:
      return (<div className={className} style={_style} {...rest}>{item}</div>)
  }
}

Markup.propTypes = {
  /** The markup content to render */
  value: PropTypes.string,

  type: PropTypes.oneOf(['html', 'plain', 'markdown']),

  unescape: PropTypes.bool,

  className: PropTypes.string,

  style: PropTypes.object
}

Markup.defaultProps = {
  unescape: true
}

export default Markup
